import React, { Component } from 'react';
import RegExpHelper from '../../../../../Common/Helpers/RegExpHelper';
import InputDefecto from '../../../../../Common/Components/InputDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';

class TopePagoMinimoCabal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            topePagoMinimoCabalMin: props.data.topePagoMinimoCabalMin,
            topePagoMinimoCabalMax: props.data.topePagoMinimoCabalMax,
            topePagoMinimoCabalDefault: props.data.topePagoMinimoCabalDefault
        };
    }

    onTopePagoMinimoCabalChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);
        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        //if (this.props.data.LimiteCompraCabal) {
        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }

            if (dataset.code == "topePagoMinimoCabalMin") {
                newState = {
                    ...newState,
                    topePagoMinimoCabalDefault: value
                }
            }

            this.setState(newState);
        }
        //}


    }

    onTopePagoMinimoCabalBlur(event) {
        const { value, dataset } = event.target;
        this.props.changeInput(dataset.code, value);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.data.establecerPorCuenta == false) {
            nextProps.data.topePagoMinimoCabalMin = nextProps.data.topePagoMinimoCabalMax = nextProps.data.topePagoMinimoCabalDefault = "";
        }

        this.state = {
            topePagoMinimoCabalMin: nextProps.data.topePagoMinimoCabalMin,
            topePagoMinimoCabalMax: nextProps.data.topePagoMinimoCabalMax,
            topePagoMinimoCabalDefault: nextProps.data.topePagoMinimoCabalDefault
        };
    }


    render() {
        const { onTopePagoMinimoCabalChange, onTopePagoMinimoCabalBlur } = this;
        let { data, form, changeInput, selectCheckBox } = this.props;

        let pattern0to100 = RegExpHelper.Pattern0to100();
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        let acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");

        let errorLimites
        let errorLimiteDefault

        if(this.state.topePagoMinimoCabalMin != "" && this.state.topePagoMinimoCabalMax != "" && this.state.topePagoMinimoCabalDefault != ""){
            errorLimites =  !(this.state.topePagoMinimoCabalMin<=this.state.topePagoMinimoCabalMax) 
            if(!errorLimites){
                errorLimiteDefault = !(this.state.topePagoMinimoCabalDefault >= this.state.topePagoMinimoCabalMin && this.state.topePagoMinimoCabalDefault <= this.state.topePagoMinimoCabalMax)
            }
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Tope Pago M" + acentoLetraIminuscula + "nimo"}</label>
                    <div className="container-radio radio-margin">

                        <CheckDefecto nombre={"Establecer por Cuenta"}
                            referencia={"establecerPorCuenta"}
                            check={data.establecerPorCuenta}
                            selectCheckBox={({ target }) => selectCheckBox("establecerPorCuenta", target.checked)}
                        />

                        <div className="row">
                            <div className="col-xs-2"><label className="lbl-radio label-secondary">{"Rango"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={3}
                                    value={this.state.topePagoMinimoCabalMin}
                                    data-code="topePagoMinimoCabalMin"
                                    data-validation="^([1-9]?\d|10)$"
                                    disabled={!data.establecerPorCuenta}
                                    onChange={onTopePagoMinimoCabalChange.bind(this)}
                                    onBlur={onTopePagoMinimoCabalBlur.bind(this)}
                                />
                            </div>

                            <div className="col-xs-2">
                            <label style={{position:"relative",left:"-42px"}} className="lbl-radio label-secondary">{"%"}</label>
                            <label  className="lbl-radio label-secondary">{" a"}</label>
                            </div>

                            <div className="col-xs-2" style={{ position: 'relative', right: '48px' }}>
                                <input className="form-control"
                                    maxLength={3}
                                    value={this.state.topePagoMinimoCabalMax}
                                    data-code="topePagoMinimoCabalMax"
                                    data-validation="^([1-9]?\d|10)$"
                                    disabled={!data.establecerPorCuenta}
                                    onChange={onTopePagoMinimoCabalChange.bind(this)}
                                    onBlur={onTopePagoMinimoCabalBlur.bind(this)}
                                />
                            </div>

                            <div className="col-xs-2" style={{ position: 'relative', right: '93px' }}><label className="lbl-radio label-secondary">{"%"}</label></div>

                        </div>
                        <div className="row">
                            <div className="col-xs-2"><label className="lbl-radio label-secondary">{"Rango por defecto"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={10}
                                    value={this.state.topePagoMinimoCabalDefault}
                                    data-code="topePagoMinimoCabalDefault"
                                    data-validation="^([1-9]?\d|10)$"
                                    disabled={!data.establecerPorCuenta}
                                    onChange={onTopePagoMinimoCabalChange.bind(this)}
                                    onBlur={onTopePagoMinimoCabalBlur.bind(this)}
                                />
                            </div>
                        </div>
                        {data.establecerPorCuenta && <div className="lbl-radio">
                            <CheckDefecto
                                check={data.topePagoMinimoCabalDefaultInterfaz}
                                referencia={"topePagoMinimoCabalCheck"}
                                selectCheckBox={({ target }) => selectCheckBox("topePagoMinimoCabalDefaultInterfaz", target.checked)}
                            />
                        </div>}
                        {(data.ERROR_PRODUCT["topePagoMinimoCabal"] == false && errorLimites) ? <label className="error">El límite inferior debe ser menor o igual al límite superior.</label> : null}
                        {(data.ERROR_PRODUCT["topePagoMinimoCabal"] == false && errorLimiteDefault )? <label className="error">El valor por defecto debe estar entre el límite inferior y superior.</label> : null}
                        {data.ERROR_PRODUCT["topePagoMinimoCabal"] == false && !errorLimites && !errorLimiteDefault ? <label className="error">Debe ingresar Tope Pago Mínimo.</label> : null}
                    </div>
                </div>
            </div>
        );
    }
};

export default TopePagoMinimoCabal;